import { BannersPriceField } from '../../typings/bannerPricesPopupState';
import { EditorBannerPriceId } from '../../typings/bannersEditState';
import { ValidationErrorsSet } from '../../typings/common';
import { CurrencyCode } from '../../typings/graphql-grid';

export const OPEN_BANNER_PRICE_EDITOR = 'OPEN_BANNER_PRICE_EDITOR';
export type OPEN_BANNER_PRICE_EDITOR = typeof OPEN_BANNER_PRICE_EDITOR;
export interface OpenBannerPriceEditor {
    type: OPEN_BANNER_PRICE_EDITOR;
    bannerId: EditorBannerPriceId;
}

export function openBannerPriceEditor(
    bannerId: EditorBannerPriceId
): OpenBannerPriceEditor {
    return {
        type: OPEN_BANNER_PRICE_EDITOR,
        bannerId
    };
}

export const CLOSE_BANNER_PRICE_EDITOR = 'CLOSE_BANNER_PRICE_EDITOR';
export type CLOSE_BANNER_PRICE_EDITOR = typeof CLOSE_BANNER_PRICE_EDITOR;
export interface CloseBannerPriceEditor {
    type: CLOSE_BANNER_PRICE_EDITOR;
    bannerId: EditorBannerPriceId;
}

export function closeBannerPriceEditor(
    bannerId: EditorBannerPriceId
): CloseBannerPriceEditor {
    return {
        type: CLOSE_BANNER_PRICE_EDITOR,
        bannerId
    };
}

export const RESET_BANNER_DRAFT_PRICE = 'RESET_BANNER_DRAFT_PRICE';
export type RESET_BANNER_DRAFT_PRICE = typeof RESET_BANNER_DRAFT_PRICE;
export interface ResetBannerDraftPrice {
    type: RESET_BANNER_DRAFT_PRICE;
    bannerId: EditorBannerPriceId;
}

export function resetBannerDraftPrice(
    bannerId: EditorBannerPriceId
): ResetBannerDraftPrice {
    return {
        type: RESET_BANNER_DRAFT_PRICE,
        bannerId
    };
}

export const VALIDATE_BANNER_PRICE = 'VALIDATE_BANNER_PRICE';
export type VALIDATE_BANNER_PRICE = typeof VALIDATE_BANNER_PRICE;
export interface ValidateBannerPrice {
    type: VALIDATE_BANNER_PRICE;
    bannerId: EditorBannerPriceId[];
}

export function validateBannerPrice(
    bannerId: EditorBannerPriceId[]
): ValidateBannerPrice {
    return {
        type: VALIDATE_BANNER_PRICE,
        bannerId
    };
}

export const VALIDATE_BANNER_PRICE_SUCCESS = 'VALIDATE_BANNER_PRICE_SUCCESS';
export type VALIDATE_BANNER_PRICE_SUCCESS = typeof VALIDATE_BANNER_PRICE_SUCCESS;
export interface ValidateBannerPriceSuccess {
    type: VALIDATE_BANNER_PRICE_SUCCESS;
    bannerId: EditorBannerPriceId[];
    currency: CurrencyCode;
}

export function validateBannerPriceSuccess(
    bannerId: EditorBannerPriceId[],
    currency: CurrencyCode
): ValidateBannerPriceSuccess {
    return {
        type: VALIDATE_BANNER_PRICE_SUCCESS,
        bannerId,
        currency
    };
}

export const UPDATE_BANNER_DRAFT_PRICE = 'UPDATE_BANNER_DRAFT_PRICE';
export type UPDATE_BANNER_DRAFT_PRICE = typeof UPDATE_BANNER_DRAFT_PRICE;
export interface UpdateBannerDraftPrice {
    type: UPDATE_BANNER_DRAFT_PRICE;
    bannerId: EditorBannerPriceId;
    changed: {
        field: BannersPriceField;
        value: string;
    };
    paths?: Array<string>;
}

export function updateBannerDraftPrice(
    bannerId: EditorBannerPriceId,
    changed: {
        field: BannersPriceField;
        value: string;
    },
    paths?: Array<string>
): UpdateBannerDraftPrice {
    return {
        type: UPDATE_BANNER_DRAFT_PRICE,
        bannerId,
        changed,
        paths
    };
}

export const UPDATE_BANNER_PRICE_ERRORS = 'UPDATE_BANNER_PRICE_ERRORS';
export type UPDATE_BANNER_PRICE_ERRORS = typeof UPDATE_BANNER_PRICE_ERRORS;
export interface UpdateBannerPriceErrors {
    type: UPDATE_BANNER_PRICE_ERRORS;
    bannerId: EditorBannerPriceId[];
    errors: ValidationErrorsSet;
}

export function updateBannerPriceErrors(
    bannerId: EditorBannerPriceId[],
    errors: ValidationErrorsSet
): UpdateBannerPriceErrors {
    return {
        type: UPDATE_BANNER_PRICE_ERRORS,
        bannerId,
        errors
    };
}

export type BannerPriceActions =
    | OpenBannerPriceEditor
    | CloseBannerPriceEditor
    | UpdateBannerPriceErrors
    | ValidateBannerPrice
    | ValidateBannerPriceSuccess
    | ResetBannerDraftPrice
    | UpdateBannerDraftPrice;
